'use client'

import { useEffect, useState } from 'react'
import { useRouter, useSearchParams, usePathname } from 'next/navigation'
import { toast } from '@/lib/toast'
import { resetPassword, forgotCheckId } from '@/utils/request'
import { navigateUrl } from '@/utils/client-request'
import { getPasswordError } from '@/utils/auth'

export function useVerifyResetFlow(vendor: any) {
  const router = useRouter()
  const pathname = usePathname()
  const searchParams = useSearchParams()
  const email = searchParams.get('email')
  const id = searchParams.get('id')

  const [loading, setLoading] = useState(true)
  const [btnLoading, setBtnLoading] = useState(false)
  const [valid, setValid] = useState(false)
  const [password, setPassword] = useState('')
  const [passwordRep, setPasswordRep] = useState('')

  useEffect(() => {
    if (!email || !id) {
      setLoading(false)
      return
    }
    const verify = async () => {
      const response = await forgotCheckId({ email, id })
      setValid(!!response && !response.error)
      setLoading(false)
    }
    verify()
  }, [email, id])

  const handleResetPassword = async (e?: { preventDefault?: () => void }) => {
    e?.preventDefault?.()
    if (!email) return toast.error('Имэйл хоосон байна')
    if (!id) return toast.error('ID хоосон байна')
    const err = getPasswordError(password, passwordRep)
    if (err) return toast.error(err)
    setBtnLoading(true)
    const response = await resetPassword({ email, password, verificationId: id, vendorId: vendor?.id })
    if (!response) {
      setBtnLoading(false)
      return toast.error('Сервертэй холбогдоход алдаа гарлаа')
    }
    if (response.error) {
      setBtnLoading(false)
      return toast.error(response.error)
    }
    toast.success('Амжилттай нууц үг солигдлоо 🥳')
    setTimeout(() => router.push(navigateUrl('/login', pathname)), 100)
  }

  const handleKeyDown = (event: any) => {
    if (event.key === 'Enter') handleResetPassword(event)
  }

  const goToLogin = () => router.push(navigateUrl('/login', pathname))

  return {
    loading, btnLoading, valid,
    password, setPassword, passwordRep, setPasswordRep,
    handleResetPassword, handleKeyDown, goToLogin,
  }
}
